/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { dXC_SubscribeEmailAsync } from '../generated/DataActionExtension.g';
import { IDXC_SubscribeNewsletterRealtimeResponse } from '../generated/DataServiceEntities.g';

/**
 * SubmitSubscribeFormDataActionInput Input Action
 */

export class SubscribeEmailDataActionInput implements IActionInput {
    public emailAddress: string;
    public subscribe: boolean;

    // Construct the input needed to run the action
    constructor(emailAddress: string, subscribe: boolean) {
        this.emailAddress = emailAddress;
        this.subscribe = subscribe;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => 'SubscribeEmail2020';
    public getCacheObjectType = () => 'SubscribeEmail';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: SubscribeEmailDataActionInput): IActionInput => {
    return args;
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function subscribeEmailAction(
    input: SubscribeEmailDataActionInput,
    ctx: IActionContext
): Promise<IDXC_SubscribeNewsletterRealtimeResponse> {
    // Input only needs token
    let result: IDXC_SubscribeNewsletterRealtimeResponse = {};
    try {
        result = await dXC_SubscribeEmailAsync({ callerContext: ctx }, input.emailAddress, input.subscribe);
    } catch (error) {
        console.log(error);
    }
    return Array.isArray(result) ? result[0] : result;
}

export const ISubscribeEmailDataActionAction = createObservableDataAction({
    action: <IAction<IDXC_SubscribeNewsletterRealtimeResponse>>subscribeEmailAction,
    input: createInput
});
